import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css"; 
import logo from "../Header/The_Luminis_New_Logo-removebg-preview.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const updateOffset = () => {
      const wrapper = document.querySelector("[data-role='header-wrapper']");
      const banner = document.querySelector("[data-role='promo-banner']");
      const mainHeader = document.querySelector("[data-role='main-header']");
      const bannerHeight = banner?.offsetHeight || 0;
      const headerHeight = mainHeader?.offsetHeight || 0;
      const totalHeight = bannerHeight + headerHeight;

      document.documentElement.style.setProperty("--banner-height", `${bannerHeight}px`);
      document.documentElement.style.setProperty("--main-header-height", `${headerHeight}px`);
      document.documentElement.style.setProperty("--header-offset", `${totalHeight}px`);

      if (wrapper) {
        document.documentElement.style.setProperty("--header-offset", `${wrapper.offsetHeight}px`);
      }
    };

    updateOffset();
    window.addEventListener("resize", updateOffset);

    return () => window.removeEventListener("resize", updateOffset);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => setIsOpen(false);

  return (
    <div className={styles.headerWrapper} data-role="header-wrapper">
      <div className={styles.topBanner} data-role="promo-banner">
        <span className={styles.topBannerText}>Безплатна доставка за поръчки над 70€</span>
      </div>
      <header className={styles.header} data-role="main-header">
        <div className={styles.hamburger} onClick={toggleMenu}>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
        </div>
        <Link to="/" className={styles.logo} onClick={handleClose}>
          <img src={logo} alt="Luminis Logo" className={styles.logoImage} />
        </Link>
        <nav className={`${styles.navMenu} ${isOpen ? styles.active : ""}`}>
          <Link to="/" onClick={handleClose}>Начало</Link>
          <Link to="/products" onClick={handleClose}>Продукти</Link>
          <Link to="/faq" onClick={handleClose}>Въпроси</Link>
        </nav>
      </header>
      {isOpen && (
        <div
          className={styles.overlay}
          onClick={handleClose}
          aria-label="Close navigation"
        ></div>
      )}
    </div>
  );
};

export default Header;
